(function() {
    $('.video-trigger').click(function(e){
        $(this).fadeOut();
        const newSrc = $(this).closest(".featured-link--wrap").find("iframe").attr('src') + "&autoplay=1";
        $(this).closest(".featured-link--wrap").find("iframe").attr("src", newSrc);
        $(this).closest(".featured-link--half").addClass("video-open");
    });
})();

/*============================================================================
  Announcement Popup ( Whatarmy 01/15/2021)
==============================================================================*/

$(function() {
  
  var modal = $('#popup-modal');
  
  $('.promo-banner__content a').on('click',function(e){
    e.preventDefault();
    modal.fadeIn();
  });

  $('.popup-close').on('click',function(e){
    modal.fadeOut();
  });
  
});